<script setup lang="ts">
import VerticalAlignChildrenWrapper from '@components/layout-wrapper/vertical-align-children-wrapper.vue';
import HorizontalAlignChildrenWrapper from '@components/layout-wrapper/horizontal-align-children-wrapper.vue';
import ProductImage from '@src/product/components/product-image.vue';
import { usePaginationComposable } from '@src/pagination/pagination-composable.ts';
import apiClient from '@src/api/api-client.ts';
import { ExpressPickUserFeed } from '@src/express-pick/interfaces/express-pick-user-feed.ts';
import Pagination from '@src/pagination/pagination.vue';
import Text from '@components/text.vue';
import dateTimeUtil from '../utils/date-time-util.ts';
import Tag from '@components/tag.vue';
import ItemLoader from '@components/loader/item-loader.vue';

const { data, currentPage, maxPage, load, loading } = usePaginationComposable<ExpressPickUserFeed>(async (currentPage) => {
    return (await apiClient.get('/be/express-pick/current-user-feed/' + currentPage)).data;
});

defineExpose({ load });
</script>

<template>
    <VerticalAlignChildrenWrapper v-if="!loading" gap-top="2" avoid-outer-gap separator>
        <HorizontalAlignChildrenWrapper v-for="entry in data" :key="entry.serial" center-children gap="3">
            <ProductImage size="xs" :border="false" :product="entry.product"/>
            <VerticalAlignChildrenWrapper gap-bottom="1">
                <Tag v-if="entry.inStockOnUserBin" tag-color="green" tag-value="aktuell gepickt"/>
                <div>
                    <Text bold gap="1">{{ entry.product.name }}</Text>
                    <Text gap="1">Lagerfach: {{ entry.bin.binCode }}</Text>
                    <Text gap="1">Gepickt: {{ dateTimeUtil.formatDatetimeToView(entry.pickedAt) }}</Text>
                    <Text v-if="entry.product.serialNumberRequired" gap="1">Seriennummer: {{ entry.serial }}</Text>
                    <Text v-else gap="1">Anzahl: {{ entry.quantity }}</Text>
                </div>
            </VerticalAlignChildrenWrapper>
        </HorizontalAlignChildrenWrapper>
        <Pagination v-model:current-page="currentPage" :max-page="maxPage"/>
    </VerticalAlignChildrenWrapper>
    <ItemLoader v-else/>
</template>
